module ScrollToHighlighted {
  export function construct(): void {
    if (document.documentElement.scrollTop != 0) {
      return;
    }

    const highlightedElements = document.getElementsByClassName("highlighted");
    if (highlightedElements.length == 0) {
      return;
    }
    const highlightedElement = highlightedElements[0];

    let scrollToY = getScrollTargetY(highlightedElement);
    scrollToY -= (screen.height / 2);
    window.scrollTo({
      top: scrollToY//,
      //behavior: 'smooth'
    });
  }

  function getScrollTargetY(element: Element): number {
    const boundingRectangle = element.getBoundingClientRect();
    //const totalOffset = getTotalOffset(element);
    //return boundingRectangle.top - totalOffset;
    return boundingRectangle.bottom;
  }

  //function getTotalOffset(highlightedElement: Element): number {
  //  const navigationHeight = getFirstElementHeightOr0("topbar");
  //  const titleHeight = getFirstElementHeightOr0("page-titles");
  //  const tableHeaderHeight = getTableHeaderHeightOr0();
  //  const stickyHeight = getStickyHeight(highlightedElement);
  //  const padding = 40;
  //  return navigationHeight + titleHeight + tableHeaderHeight + stickyHeight + padding;
  //}

  //function getTableHeaderHeightOr0(): number {
  //  const element = document.querySelector(".quikaid-calendar thead tr th");
  //  return element == null ? 0 : element.clientHeight;
  //}

  //function getFirstElementHeightOr0(className: string): number {
  //  const elements = document.getElementsByClassName(className);
  //  return elements.length == 0 ? 0 : elements[0].clientHeight;
  //}

  //function getStickyHeight(highlightedElement: Element): number {
  //  const stickys = document.getElementsByClassName("sticky");
  //  if (stickys.length == 0) {
  //    return 0;
  //  }
  //  const highlightedBoundingRect = highlightedElement.getBoundingClientRect();
  //  for (var i = 0; i < stickys.length; i++) {
  //    const sticky = stickys[i];
  //    const stickyBoundingRect = sticky.getBoundingClientRect();
  //    //Exclude any sticky elements below our target
  //    if (stickyBoundingRect.top > highlightedBoundingRect.top) {
  //      continue;
  //    }
  //    //Exclude sticky elements not on the same column, such as sidebars
  //    if (stickyBoundingRect.left != highlightedBoundingRect.left) {
  //      continue;
  //    }
  //    //We only need the first one since our current sticky system would just cause multiple to overlap anyways
  //    return sticky.clientTop;
  //  }
  //  //Stickys found but none had a position that affected the scroll
  //  return 0;
  //}
}

document.addEventListener("DOMContentLoaded", function () {
  ScrollToHighlighted.construct();
});